import { AnalyticsTypes } from '../../../../middleware/google-analytics';
import * as TrackingConstants from '../../../../EventTrackingConstants';
import { PROFILE_GA_CATEGORY } from '../../constants';

const CLICK_UNBOOKABLE_CTA = '@@unbookablesection/CLICK_UNBOOKABLE_CTA';

export const ActionTypes = {
    CLICK_UNBOOKABLE_CTA,
};

export const trackClickUnbookableCTA = () => ({
    type: ActionTypes.CLICK_UNBOOKABLE_CTA,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Unbookable CTA',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TrackingConstants.TARGETS.BOOK_AN_APPOINTMENT,
                Component: TrackingConstants.TARGETS.TIMESGRID,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Element: TrackingConstants.TARGETS.TIMESGRID_PROVIDER_PHONE,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                EventAction: 'click unbookable section CTA',
            },
        },
    },
});
